import {onClick} from '../abstract/helpers.js';

export class Notifications {
  constructor() {
    if(document.querySelector('.notifications .expand')) {
      onClick(document.querySelector('.notifications .expand'), function () {
        document.querySelector('.notifications').classList.toggle("expanded");

        return false;
      });

      //notifications scroll fix
      if(document.querySelector('.notifications')) {
        const scrollableDiv = document.querySelector('.notifications');
        scrollableDiv.scrollTop = scrollableDiv.scrollHeight;

        onClick(document.querySelector('.notifications .expand_wrapper .expand'), function (e) {
          e.preventDefault();
          
          const scrollableDiv = document.querySelector('.notifications');
          scrollableDiv.scrollTop = scrollableDiv.scrollHeight;

        }.bind(this));
      }


    }
  }
}
